const liveURL = "https://shiba-sensei-mongodb-25a2a83231bf.herokuapp.com/";
const testURL = "http://localhost:5000";

export { liveURL, testURL };
